module.exports = __webpack_public_path__ + "static/media/enterprisecenter-banner.9a5db44e.png";